import {Component, OnInit} from '@angular/core';
import {SetVideoStateTypeAction} from '../../../shared/stores/root-store/actions/video.action';
import {VideoStateEnum} from '../../../../enums/video-state.enum';
import {SendAction} from '../../../shared/stores/root-store/actions/external-actions.action';
import {BaseComponent} from '../base-overlay/base.component';
import {
    selectCurrentTimeFromState,
    selectFormsFromState
} from '../../../shared/stores/root-store/selectors/video.selector';
import {
    distinctUntilChanged, filter, map, takeUntil, tap
} from 'rxjs/operators';

@Component({
    selector: 'eocm-button',
    templateUrl: './button-overlay.component.html',
    styleUrls: [
        './button-overlay.component.scss',
        '../../overlay.component.scss'
    ]
})
export class ButtonOverlayComponent extends BaseComponent implements OnInit {
    private isActiveFormRequired = false;
    private isStable = false;

    ngOnInit() {
        super.ngOnInit();

        this.store.select(selectFormsFromState)
            .pipe(
                map(forms => forms.some(form => {
                    if (form.shown) {
                        return form.fields.some(field => field.required)
                    }
                    return false;
                })),
                takeUntil(this.destroy$)
            )
            .subscribe(isActiveFormRequired => {
                this.isActiveFormRequired = isActiveFormRequired;
            })

        if (this.overlay.pauseOnShow) {
            this.store.select(selectCurrentTimeFromState).pipe(
                tap(currentTime => this.isStable = this.overlayService.isStable(currentTime, this.overlay)),
                map(() => this.isStable && this.isVisible),
                distinctUntilChanged(),
                filter(Boolean),
                takeUntil(this.destroy$)
            ).subscribe(() => {
                this.store.dispatch(SetVideoStateTypeAction({
                    videoState: VideoStateEnum.Interaction
                }))
            });
        }
    }

    override onClick(event: MouseEvent) {
        event.stopPropagation();
        const hasNavigation = Boolean(this.overlay.navigateTo);

        this.trackEvent();
        this.executeActions();

        if (hasNavigation) {
            this.navigate();
        } else {
            this.playIfPaused();
        }
    }

    private getTimeToFullVisibility() {
        const animationStart = this.overlay.animations?.start.duration ?? 0;
        const transitionStart = this.overlay.transition?.start.duration ?? 0;
        return this.overlay.time.start + animationStart + transitionStart;
    }

    private playIfPaused() {
        if (this.videoState === VideoStateEnum.Interaction && !this.isActiveFormRequired) {
            this.store.dispatch(SetVideoStateTypeAction({
                videoState: VideoStateEnum.Playing
            }))
        }
    }

    private executeActions() {
        this.overlay.actions?.forEach(actionId => {
            this.store.dispatch(SendAction({
                actionId
            }))
        });
    }
}
